import apiClient from './client'
import type { Ping, Incident, UptimeStats, PingRegion, RegionalUptimeStatsResponse } from '../types'

export interface PingsListResponse {
  pings: Ping[]
  total: number
}

export interface IncidentsListResponse {
  incidents: Incident[]
  total: number
}

export const pingsApi = {
  list: async (
    appId: string,
    params?: {
      skip?: number
      limit?: number
      hours?: number
      region?: PingRegion
    }
  ): Promise<PingsListResponse> => {
    const response = await apiClient.get<PingsListResponse>(`/apps/${appId}/pings`, {
      params,
    })
    return response.data
  },

  getStats: async (appId: string, hours = 24): Promise<UptimeStats> => {
    const response = await apiClient.get<UptimeStats>(`/apps/${appId}/pings/stats`, {
      params: { hours },
    })
    return response.data
  },

  getRegionalStats: async (appId: string, hours = 24): Promise<RegionalUptimeStatsResponse> => {
    const response = await apiClient.get<RegionalUptimeStatsResponse>(
      `/apps/${appId}/pings/stats/regional`,
      { params: { hours } }
    )
    return response.data
  },

  listIncidents: async (
    appId: string,
    params?: {
      resolved?: boolean
      skip?: number
      limit?: number
    }
  ): Promise<IncidentsListResponse> => {
    const response = await apiClient.get<IncidentsListResponse>(`/apps/${appId}/pings/incidents`, {
      params,
    })
    return response.data
  },

  trigger: async (appId: string): Promise<Ping> => {
    const response = await apiClient.post<Ping>(`/apps/${appId}/pings/trigger`)
    return response.data
  },
}

export type { Ping, Incident, UptimeStats, PingRegion, RegionalUptimeStatsResponse }
